import type { RecipeExportDetail } from "@/lib/manufacturing/recipeCsvExport";

export type RenderRecipesBomPdfResult =
  | { ok: true; blob: Blob }
  | { ok: false; error: string };

/** Lazy-load @react-pdf/renderer for multi-recipe BOM PDF export. */
export async function renderRecipesBomPdfToBlob(
  recipes: ReadonlyArray<RecipeExportDetail>,
): Promise<RenderRecipesBomPdfResult> {
  try {
    const [{ pdf }, { RecipesBomPdf }] = await Promise.all([
      import("@react-pdf/renderer"),
      import("./RecipesBomPdf"),
    ]);
    const generatedAt = new Date().toISOString().slice(0, 10);
    const blob = await pdf(
      RecipesBomPdf({ recipes, generatedAt }),
    ).toBlob();
    return { ok: true, blob };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : "Failed to render recipes PDF",
    };
  }
}
